<template>
    <div class="review-wrap"  ref="review">
        <div class="review">
            <Header class="app-header"></Header>
            <div class="review-content">
                <div class="review-item" v-for="(item,index) in reviewData" :key="index" @click="$router.push(`/newsDetails/${item.id}`)">
                    <div class="img-wrap">
                        <img :src="item.photo" alt="">
                    </div>
                    <div class="item-title">
                        <span>{{item.name}}</span>
                    </div>
                </div>
            </div>
            <Footer class="app-footer"></Footer>
        </div>
    </div>

</template>

<script>
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';
import BScroll from 'better-scroll';
export default {
    name:"Review",
    components: {
        Footer,
        Header
    },
    data(){
        return{
            reviewData:[],
             page: 1,
            pageSize: '8',
            idData: []
        }
    },
     created() {
        this.getNewsPrevious()
        setTimeout(() => {
            this.$nextTick(() => {
                this.initScroll()
            })
        }, 500)
    },
    methods: {
        initScroll() {
            this.scroll = new BScroll(this.$refs.review, {
                scrollY: true,
                click: true,
                probeType: 3,
                pullUpLoad: {
                    threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
                    stop: 20
                },
            })
            this.scroll.on('pullingUp', async (params) => {
                const {
                    page,
                    pageSize
                } = this
                this.page = page + 1;
                await this.getNewsPrevious({
                    page: this.page,
                    pageSize
                })
                this.$nextTick(() => {
                    this.scroll.refresh()
                    this.scroll.finishPullUp()
                })
            })
        },
        async getNewsPrevious() {
            const result = await this.$http.home.getNewsPrevious({
                pageSize: this.pageSize,
                page: this.page
            })
            if (result.code === 200) {
                this.reviewData.push(...result.data)
            } else {
                return
            }

        },
    },

}
</script>

<style lang="less">
    .review-wrap{
        height: 100vh;
        widows: 100vw;
        overflow: hidden;
        .review-content{
            padding: 0 10px;
            .review-item{
                .img-wrap{
                    height: 400px;
                    width: 100%;
                    overflow: hidden;
                    
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .item-title{
                    padding-left: 10px;
                    font-size: 38px;
                    height: 80px;
                    line-height: 80px;
                    font-weight: 600;
                }
            }
        }
    }

</style>